import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './context/UserContext';
import TelegramRouter from './components/TelegramRouter/TelegramRouter';
import UrlPersistence from './components/UrlPersistence/UrlPersistence';
import Welcome from './screens/Welcome/Welcome';
import Letter from './screens/Letter/Letter';
import Result from './screens/Result/Result';
import Layout from './components/Layout/Layout';
import Loading from './components/Loading/Loading';
import { preloadImages } from './utils/imagePreloader';
import { useNetworkStatus } from './hooks/useNetworkStatus';
import { showTelegramAlert } from './utils/telegramActions';

import sleighIcon from './assets/images/icons/sleigh.webp';
import tinselIcon from './assets/images/icons/tinsel.webp';
import snowflakeIcon1 from './assets/images/icons/snowflake1.webp';
import snowflakeIcon2 from './assets/images/icons/snowflake2.webp';
import giftIcon from './assets/images/logos/gift.webp';
import yandexKitLogo from './assets/images/logos/yandex-kit.webp';

function AppContent() {
    const { user, loading, error, initializeUser } = useUser();
    const [imagesLoaded, setImagesLoaded] = useState(false);
    useNetworkStatus();

    useEffect(() => {
        const images = [
            sleighIcon,
            tinselIcon,
            snowflakeIcon1,
            snowflakeIcon2,
            giftIcon,
            yandexKitLogo
        ];

        preloadImages(images).then(() => {
            setImagesLoaded(true);
        });
    }, []);

    useEffect(() => {
        if (error) {
            showTelegramAlert(error, () => {
                initializeUser();
            });
        }
    }, [error, initializeUser]);

    if (loading || !user || !imagesLoaded) {
        return <Loading />;
    }

    return (
        <BrowserRouter basename="/yandex-kit">
            <UrlPersistence />
            <TelegramRouter />

            <Routes>
                <Route element={<Layout />}>
                    <Route
                        path="/"
                        element={
                            user.has_sent_letter ? <Navigate to="/result" replace /> : <Welcome />
                        }
                    />
                    <Route
                        path="/letter"
                        element={
                            user.has_sent_letter ? <Navigate to="/result" replace /> : <Letter />
                        }
                    />
                    <Route path="/result" element={<Result />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

function App() {
    return (
        <UserProvider>
            <AppContent />
        </UserProvider>
    );
}

export default App;


